module.exports = __webpack_public_path__ + "static/media/apple-pay.7e1f01f7.svg";